import React, { forwardRef, PropsWithChildren } from 'react';
import styled from 'styled-components';
import { MessageSectionProps } from './models';
import * as styles from './styles';
import Subtitle from '../onlineSubtitle/onlineSubtitle';
import Title from '../onlineTitle/Title';
import { Card } from '../card/Card';
import theme, { size } from '../../themes/online';
import { useMediaQuery } from 'react-responsive';

const messageContent = (children: JSX.Element, headerImage: string, title: string, subtitle: string) => {
  return (
    <>
      {children ? (
        children
      ) : (
        <>
          {headerImage ? <img className="header-image" src={headerImage} /> : ''}
          {title ? <Title className="message-card-title">{title}</Title> : ''}
          {subtitle ? (
            <Subtitle className="message-card-subtitle" alignLeft={false}>
              {subtitle}
            </Subtitle>
          ) : (
            ''
          )}
        </>
      )}
    </>
  );
};

export const MessageSection = styled(
  forwardRef<HTMLDivElement, PropsWithChildren<MessageSectionProps>>(
    ({ className, children, headerImage, title, subtitle }, ref) => {
      const content = messageContent(children, headerImage, title, subtitle);

      const isMobile = useMediaQuery({
        query: theme.device.max.laptopS,
      });

      return isMobile ? (
        <div className={className} ref={ref}>
          {content}
        </div>
      ) : (
        <Card className={className} ref={ref}>
          {content}
        </Card>
      );
    }
  )
)`
  ${styles.MessageSection}
`;
